<div #videoPlayer style="position: relative; width: 100%; height: 100%;">
    <video [id]="mediaPlayerUID + 'player-' + id" controls="controls" disablepictureinpicture disableremoteplayback
        width="100%" height="100%" [volume]="volume" controlsList="nodownload nofullscreen noremoteplayback"
        [autoplay]="isAutoPlay" [loop]="isOnLoop">
        <source [src]="src" [type]="type" />
    </video>
    <div *ngIf="isWebkit" class="overlay-3-dots"></div>
</div>